// TODO: Remove Redux and replace with Context
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import { CustomerName } from '../models/be/Customer';
import FilterSettings from '../models/be/FilterSettings';
import RootState from '../models/RootState';
import {
	SET_CANDIDATE_TEXT_SEARCH,
	ValueAction,
	SET_TIME_FILTER,
	SET_SELECTED_CUSTOMER_ID,
	ADD_FIELD_NAME_FOR_FILE_BEING_UPLOADED,
	REMOVE_FIELD_NAME_FOR_FILE_BEING_UPLOADED,
	SET_FILTER_SETTINGS,
	SET_CUSTOMER_DETAILS,
	SET_REFEREE_TEXT_SEARCH
} from './actions';

const stringValueActionReducer =
	(type: string) =>
	(state = '', action: ValueAction<string>) =>
		action.type === type ? action.value : state;

const numberValueActionReducer =
	(type: string) =>
	(state: number = null, action: ValueAction<number>) =>
		action.type === type ? action.value : state;

const filterSettingsActionReducer = (state: FilterSettings = null, action: ValueAction<number[]>) =>
	action.type === SET_FILTER_SETTINGS ? action.value : state;

const customerActionReducer = (state: CustomerName = null, action: ValueAction<number[]>) =>
	action.type === SET_CUSTOMER_DETAILS ? action.value : state;
const appReducer = combineReducers({
	candidateTextSearch: stringValueActionReducer(SET_CANDIDATE_TEXT_SEARCH),
	refereeTextSearch: stringValueActionReducer(SET_REFEREE_TEXT_SEARCH),
	filterSettings: filterSettingsActionReducer,
	customerDetails: customerActionReducer,
	toFrom: stringValueActionReducer(SET_TIME_FILTER),
	selectedCustomerId: numberValueActionReducer(SET_SELECTED_CUSTOMER_ID),
	fieldNamesForFilesBeingUploaded: (fieldNames: string[] = [], action: { type: string; fieldName: string }) => {
		if (action.type === ADD_FIELD_NAME_FOR_FILE_BEING_UPLOADED) {
			return [...fieldNames, action.fieldName];
		}
		if (action.type === REMOVE_FIELD_NAME_FOR_FILE_BEING_UPLOADED) {
			return Array.from(fieldNames.filter((fieldName: string) => fieldName !== action.fieldName));
		}
		return fieldNames;
	}
});

export default appReducer;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
